module.exports = {
    BASE_URL: 'https://uccinfrabd.com/cms/wp-json/',
    MAP_API_KEY: 'AIzaSyB3nEqKsliw_EQSpaxAq6R8hOUwpGyxJ9s'
}
